module.exports = "<app-processed-claims></app-processed-claims>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/billing-provider/processed-claims-prov/processed-claims-prov.component.html
// module id = 2407
// module chunks = 66